import { Button } from "flowbite-react";
import { HiX } from "react-icons/hi";
import { customerFilters } from "../../utils";

export const SelectedFilters = ({ selectedFilters, handleFilterToggle }) => {
  const selectedFiltersWithNames = selectedFilters
    .map((filterKey) => {
      const filter = customerFilters[filterKey];
      return filter ? { filterKey, name: filter.name } : null;
    })
    .filter(Boolean);

  return (
    <div className="flex items-center gap-2 border-b bg-white px-5 py-4 dark:bg-gray-900">
      {selectedFiltersWithNames.map((filter) => (
        <Button
          color="light"
          pill
          key={filter.filterKey}
          size="xs"
          onClick={() => handleFilterToggle(false, filter)}
        >
          {filter.name}
          <HiX className="ml-2 h-4 w-3" />
        </Button>
      ))}
    </div>
  );
};
